import { PayRateRequestError } from '../../../api/staff-pay-rates';

export type PayRateAction = 'load' | 'set' | 'remove' | 'salaried';

const CONFLICT: Record<PayRateAction, string> = {
  set: "This rate has already started and can't be changed; set a new rate from a later date",
  remove: "This rate has already started and can't be removed",
  load: 'Something went wrong. Please try again.',
  salaried: 'Something went wrong. Please try again.',
};

const BAD_REQUEST: Record<PayRateAction, string> = {
  set: "The amount or date wasn't accepted. Check both and try again.",
  salaried: "That change wasn't accepted. Please try again.",
  remove: "That rate couldn't be removed. Please try again.",
  load: 'Something went wrong. Please try again.',
};

/** What to tell the viewer for each status the pay-rate endpoints can return. */
export function payRateErrorMessage(err: unknown, action: PayRateAction): string {
  const status = err instanceof PayRateRequestError ? err.status : null;
  if (status === 400) return BAD_REQUEST[action];
  if (status === 403) {
    return action === 'load'
      ? "You don't have permission to see pay rates."
      : "You can't change this person's rates";
  }
  if (status === 404) {
    return action === 'remove'
      ? 'That rate was already removed.'
      : "We couldn't find this person's pay rates.";
  }
  if (status === 409) return CONFLICT[action];
  return 'Something went wrong. Please try again.';
}

/** Statuses after which what is on screen may be out of date. */
export function shouldReload(err: unknown, action: PayRateAction): boolean {
  if (!(err instanceof PayRateRequestError)) return false;
  if (err.status === 409) return action === 'set' || action === 'remove';
  return err.status === 404 && action === 'remove';
}
